import { POLICY_PAGES } from "../../api/src/shared/site-pages.js";
import { el } from "../lib/dom.js";

/**
 * The links to the privacy policy and the terms (g96), shown wherever a
 * person gives Trayflux something about themselves: the sign-in screen, the
 * guest's name prompt, and Settings.
 *
 * The pages are the public site's. Each link names a path on the app's own
 * origin that the API redirects there, because the app does not know the
 * site's address. They open in a new tab, so a half-typed code or name is
 * still here afterwards, and carry no `data-link`: the router leaves them to
 * the browser.
 */
export function policyLinks(): HTMLElement {
  return el("nav", {
    class: "policy-links",
    attrs: { "aria-label": "Policies" },
    children: Object.values(POLICY_PAGES).map(page =>
      el("a", { text: page.label, attrs: { href: page.via, target: "_blank", rel: "noopener noreferrer" } })),
  });
}
